const t = 1;
var s = /* @__PURE__ */ ((r) => (r.Submit = "submit", r.Reset = "reset", r.SetValues = "setValues", r.SetErrors = "setErrors", r))(s || {});
export {
  t as FORM_VALID,
  s as ImperativeActionTypesEnum
};
